var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChips(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 170"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 173",
    d: "M181.408 217.768a.535.535 0 0 1-.095.134 6.518 6.518 0 0 1-1.519.871.881.881 0 0 1-.185.03 1.614 1.614 0 0 0-.147-.151 3.618 3.618 0 0 0-2.917-.729 3.252 3.252 0 0 0-1.819.918l-1.605-.9-.151-.137.082-.733a1.478 1.478 0 0 1 .171.027 6.452 6.452 0 0 0 2.661.277 9.773 9.773 0 0 0 1.478-.287 6.5 6.5 0 0 0 2.991-1.923 6.664 6.664 0 0 0 1.481-2.732 6 6 0 0 0 .2-2.044c.189.184.368.379.568.55a3.147 3.147 0 0 0 1.256.667l.087.373v1.312l-.088.333a3.325 3.325 0 0 0-1.608.993 3.553 3.553 0 0 0-.911 1.891 2.646 2.646 0 0 0 .072 1.258",
    transform: "translate(-163.943 -201.288)",
    style: {
      fill: "#24ae5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 174",
    d: "M135.793 137.222a6 6 0 0 1-.2 2.044 6.665 6.665 0 0 1-1.48 2.734 6.5 6.5 0 0 1-2.991 1.923 9.772 9.772 0 0 1-1.478.287 6.452 6.452 0 0 1-2.661-.277 1.484 1.484 0 0 0-.171-.027 3.307 3.307 0 0 0-.664-2.151 3.226 3.226 0 0 0-1.872-1.285l-.083-.352a.09.09 0 0 0-.009-.034l.011-1.082a2.5 2.5 0 0 0 .033-.26.34.34 0 0 1 .259-.361 3.516 3.516 0 0 0 1.935-1.665 3.758 3.758 0 0 0 .327-2.459l.056-.108h.038l.044-.038c.082-.051.161-.107.246-.151.457-.237.915-.472 1.372-.707a6 6 0 0 0 .534.415 3.468 3.468 0 0 0 2.614.48 3.361 3.361 0 0 0 1.719-.874.814.814 0 0 1 .221.045c.384.2.763.409 1.144.614l.043.06.306.548c-.013.126-.035.253-.038.379a3.493 3.493 0 0 0 .319 1.563c.121.259.281.5.424.75m-7.857 4.6a.94.94 0 0 0 .093.142 3.834 3.834 0 0 0 3.65 1.242 3.831 3.831 0 0 0 2.967-4.922 3.5 3.5 0 0 0-1.321-1.854 3.628 3.628 0 0 0-1.974-.776 3.866 3.866 0 0 0-4.082 2.6 3.7 3.7 0 0 0 .667 3.567",
    transform: "translate(-117.705 -128.118)",
    style: {
      fill: "#4fba6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 175",
    d: "M211.872 124.661a3.361 3.361 0 0 1-1.719.874 3.468 3.468 0 0 1-2.614-.48 6 6 0 0 1-.534-.415l.377-.183.835-.167a5.715 5.715 0 0 1 1.952-.062c.509.075 1.011.2 1.514.317a.7.7 0 0 1 .189.115",
    transform: "translate(-196.204 -119.512)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 176",
    d: "M333.128 156.56c-.143-.25-.3-.491-.424-.75a3.493 3.493 0 0 1-.319-1.563c0-.127.025-.253.038-.379l.082-.233a3.788 3.788 0 0 1 .472.344 6.736 6.736 0 0 1 1.979 3.721.357.357 0 0 1 0 .076 3.145 3.145 0 0 1-1.257-.667c-.2-.171-.379-.366-.568-.55",
    transform: "translate(-315.04 -147.456)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 177",
    d: "M332.6 277.29a2.646 2.646 0 0 1-.072-1.258 3.553 3.553 0 0 1 .911-1.891 3.325 3.325 0 0 1 1.608-.993c-.138.5-.242 1.018-.423 1.5a5.689 5.689 0 0 1-1.266 1.981c-.2.2-.4.4-.6.592a.486.486 0 0 1-.153.064",
    transform: "translate(-315.136 -260.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 178",
    d: "M206.624 356.479a3.252 3.252 0 0 1 1.819-.918 3.619 3.619 0 0 1 2.917.729 1.612 1.612 0 0 1 .147.151c-.283.1-.56.226-.85.3a6.233 6.233 0 0 1-2.123.156 14.089 14.089 0 0 1-1.518-.3l-.392-.123",
    transform: "translate(-195.842 -338.927)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 179",
    d: "M175.362 33.8c.572 0 1.144-.013 1.716-.009a.293.293 0 0 1 .309.322q.009.665 0 1.33a.36.36 0 0 1-.393.357c-.221.005-.442 0-.663 0h-.171l-.787-.035-.012-1.963",
    transform: "translate(-166.211 -33.785)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 180",
    d: "m159.573 72.079.787.035h.171a.584.584 0 0 1 .182.533q-.013.508 0 1.017a.412.412 0 0 1-.22.409.832.832 0 0 1-.179.043h-1.619v-2.005l.881-.038",
    transform: "translate(-150.411 -70.103)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 181",
    d: "M0 227.471v1.233a.35.35 0 0 0 .392.4c.221.006.442 0 .663 0H1.1a.062.062 0 0 0 .032 0H2.03v-2l-.943-.036c-.236.012-.473.028-.709.034-.269.008-.378.111-.379.375",
    transform: "translate(0 -217.098)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 182",
    d: "M2.027 151.914q0-.981.005-1.963c-.254 0-.507 0-.761-.008a1.307 1.307 0 0 1-.205-.037c-.229.013-.458.032-.687.037-.276.007-.371.094-.372.367v1.192c0 .314.1.406.419.412.223 0 .446.022.669.034a.273.273 0 0 0-.195.3v1.342a.273.273 0 0 0 .2.3l.943.036h.858v-1.969l-.872-.034",
    transform: "translate(-.005 -143.919)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 183",
    d: "M55.442 35.818v-1.97h1.791v1.967a1.326 1.326 0 0 1-.2.037c-.229.008-.458.009-.687.012a.931.931 0 0 0-.195-.047c-.237-.006-.474 0-.711 0",
    transform: "translate(-52.549 -33.842)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 184",
    d: "m55.437 346.43-.006-1.968h1.795v1.967h-1.79",
    transform: "translate(-52.539 -328.445)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 185",
    d: "m143.186 35.86-.881.038a1.337 1.337 0 0 0-.206-.036c-.232-.005-.464 0-.7 0v-1.965h1.768l.012 1.963",
    transform: "translate(-134.023 -33.884)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 186",
    d: "M175.49 110.9h.74a.832.832 0 0 0 .179-.043c.262.015.524.019.784.051a.546.546 0 0 1 .264.146c.038.033.039.117.041.179.007.2.006.4.008.595l-.377.183c-.458.235-.916.47-1.372.707-.085.044-.164.1-.246.151a.038.038 0 0 0-.026-.007q0-.98.005-1.96",
    transform: "translate(-166.328 -106.885)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 187",
    d: "M175.35 358.273v-1.116a1.766 1.766 0 0 1 .025-.207l1.605.9.392.123a.3.3 0 0 1-.318.312c-.569 0-1.138 0-1.706-.008",
    transform: "translate(-166.199 -340.294)",
    style: {
      fill: "#e64d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 188",
    d: "m327.643 147.832-.082.233-.306-.548.388.315",
    transform: "translate(-310.178 -141.654)",
    style: {
      fill: "#4fba6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 189",
    d: "m326.463 146.508-.043-.06.043.06",
    transform: "translate(-309.386 -140.64)",
    style: {
      fill: "#5ea5ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 190",
    d: "M180.322 185.787a3.7 3.7 0 0 1-.667-3.567 3.866 3.866 0 0 1 4.082-2.6 3.628 3.628 0 0 1 1.974.776c.106.217.215.434.319.653a3.449 3.449 0 0 1 .206 2.487 3.733 3.733 0 0 1-2.764 2.737 3.692 3.692 0 0 1-2.576-.221l-.575-.263",
    transform: "translate(-170.09 -172.084)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 191",
    d: "m196.076 200.416.575.263a3.692 3.692 0 0 0 2.576.221 3.733 3.733 0 0 0 2.764-2.737 3.449 3.449 0 0 0-.206-2.487c-.1-.218-.213-.435-.319-.652a3.5 3.5 0 0 1 1.321 1.854 3.831 3.831 0 0 1-2.967 4.922 3.834 3.834 0 0 1-3.65-1.242.94.94 0 0 1-.093-.142",
    transform: "translate(-185.844 -186.712)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 192",
    d: "M126.867 150.024a3.758 3.758 0 0 1-.327 2.459 3.516 3.516 0 0 1-1.935 1.665.341.341 0 0 0-.259.361 2.478 2.478 0 0 1-.033.26v-.882c.1.006.143-.02.164-.131a3.081 3.081 0 0 1 .168-.6c.164-.4.35-.794.526-1.191l-.005-.075-.856-.011v-1.963h.4c.163-.008.325-.026.487-.039h.213l.69.032-.056.8.82-.686",
    transform: "translate(-117.822 -143.886)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 193",
    d: "m142.3 113.717-.69-.032h-.213v-1.963h1.779q0 .98-.005 1.96l-.018.046h-.038l-.82-.009",
    transform: "translate(-134.019 -107.698)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 194",
    d: "m157.685 150.548.82.009-.056.109-.82.686.056-.8",
    transform: "translate(-149.404 -144.528)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 195",
    d: "m175.145 149.8.018-.046a.038.038 0 0 1 .026.007l-.044.038",
    transform: "translate(-166.006 -143.776)",
    style: {
      fill: "#7b98c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 196",
    d: "m124.2 74.037.012-1.93.031-.032c.218 0 .437 0 .655-.008a1.234 1.234 0 0 0 .2-.039h.7a1.33 1.33 0 0 1 .206.036v2.005h-.9l-.855-.008-.028-.034h-.015",
    transform: "translate(-117.717 -70.055)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 197",
    d: "m124.314 72.834-.031.032-.008-.038.039.005",
    transform: "translate(-117.79 -70.814)",
    style: {
      fill: "#d3eefa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 198",
    d: "m126.9 277.7-.151-.137.082-.733a3.307 3.307 0 0 0-.664-2.151 3.226 3.226 0 0 0-1.867-1.279l.428 1.668h-.476l-.028.029-.013 1.931h.016a.059.059 0 0 0-.006.033h.032l-.026-.031.026.031.856.01v1.965h1.767v-1.116a1.765 1.765 0 0 1 .025-.207",
    transform: "translate(-117.724 -261.046)",
    style: {
      fill: "#f4fbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 199",
    d: "M40.7 304.932v2h-1.768v-2.007l.861-.035a1.062 1.062 0 0 0 .18.035c.243.006.486 0 .729.007",
    transform: "translate(-36.9 -290.916)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 200",
    d: "M2.9 270.59h-.858v-2.007l.861-.035v-1.967l-.861-.006H1.139a.063.063 0 0 1-.032 0l-.045.029a.326.326 0 0 0-.168.319c.005.423-.007.846.008 1.269a1.22 1.22 0 0 0 .125.348c-.229.013-.457.03-.686.039s-.335.113-.335.326v1.288a.363.363 0 0 0 .408.392h.6a1.06 1.06 0 0 0-.114.315c-.013.448-.008.9 0 1.346a.288.288 0 0 0 .311.312h1.693L2.9 270.59",
    transform: "translate(-.005 -254.573)",
    style: {
      fill: "#e64d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 201",
    d: "M40.667 227.736v2l-.91.007-.861-.006v-2h.858l.908.006",
    transform: "translate(-36.867 -217.733)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 202",
    d: "M22.551 266.572h-.817.817",
    transform: "translate(-20.6 -254.573)",
    style: {
      fill: "#fde5a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 203",
    d: "M40.487 72.1v1.991H38.72l-.016-.038.011-1.966.862-.036h.711a.932.932 0 0 1 .195.047",
    transform: "translate(-36.688 -70.08)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 204",
    d: "M2.894 37.757h-.855l-.016-.038.011-1.965.862-.036v-1.97c-.553 0-1.105-.007-1.658-.005-.241 0-.346.111-.348.357 0 .424-.01.848.005 1.271a1.2 1.2 0 0 0 .126.345c-.228.013-.457.031-.685.038s-.336.1-.336.336v1.271a.364.364 0 0 0 .407.4h.6a1.615 1.615 0 0 0-.116.388c-.016.372 0 .745-.009 1.117a.513.513 0 0 0 .173.46 1.309 1.309 0 0 0 .205.037c.254.006.507.006.761.008.232 0 .463 0 .7-.008a1.036 1.036 0 0 0 .179-.036q0-.984-.009-1.968m-1.872 0h.04c.128-.009.257-.02.385-.028-.128.008-.257.019-.385.028h-.04",
    transform: "translate(-.003 -33.737)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 205",
    d: "m39.616 151.975-.872-.034.005-1.963c.232 0 .463 0 .7-.008a1.034 1.034 0 0 0 .179-.036l.9.007q0 1-.006 1.994h-.331c-.191.009-.383.023-.574.035",
    transform: "translate(-36.722 -143.947)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 206",
    d: "m56.321 113.635-.9-.007q0-.984-.009-1.968h1.795v1.968z",
    transform: "translate(-52.516 -107.639)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 207",
    d: "m55.4 266.587.91-.007.89.007q0 .983-.006 1.966a.035.035 0 0 0-.021.03l-.862.012c-.243 0-.486 0-.729-.007a1.06 1.06 0 0 1-.18-.035v-1.967",
    transform: "translate(-52.511 -254.581)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 208",
    d: "M55.4 188.8c.191-.012.383-.026.574-.035.11-.005.221 0 .331 0 .135 0 .27 0 .4.006.163.008.326.025.488.037q0 .983-.007 1.966l-.886.005-.908-.006v-1.969",
    transform: "translate(-52.509 -180.77)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 209",
    d: "M124.321 305.7a.076.076 0 0 1-.008-.033.075.075 0 0 1 .036 0l-.028.029",
    transform: "translate(-117.826 -291.652)",
    style: {
      fill: "#f4fbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 210",
    d: "m72.81 229.747.89.007.039-.008c.051-.008.1-.021.153-.027-.051.006-.1.019-.153.027H75.5a.09.09 0 0 0-.009-.034l.011-1.082v-.882h-1.8l-.886.005v2",
    transform: "translate(-69.009 -217.748)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 211",
    d: "m76.348 151.938-.856-.011v-1.963H73.88a.818.818 0 0 1-.148-.027l-.035-.009-.886.007q0 1-.006 1.994c.135 0 .27 0 .4.006.163.008.326.025.488.037q0 .983-.007 1.966h1.8c.1.006.143-.02.164-.131a3.077 3.077 0 0 1 .168-.6c.164-.4.35-.794.526-1.19l-.005-.075",
    transform: "translate(-69.006 -143.938)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 212",
    d: "m140.714 189.053-.005-.075.005.075",
    transform: "translate(-133.366 -180.978)",
    style: {
      fill: "#ffe07d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 213",
    d: "m76.437 270.592-.856-.01h-.032a.059.059 0 0 1 .006-.033h-.016l.013-1.931a.076.076 0 0 1-.008-.033.075.075 0 0 1 .036 0h.476l-.428-1.668-.083-.352h-1.757l-.039.008q0 .983-.006 1.966a.035.035 0 0 0-.021.03l1.819.005v.006-.006l-1.819-.005-.862.012v2h.885v1.967h2.695v-1.965m-2.65 0 .05-.011-.05.011",
    transform: "translate(-69.058 -254.573)",
    style: {
      fill: "#e64d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 214",
    d: "M75.507 37.9h-.017a.054.054 0 0 1 .006-.036h-.015l.012-1.93-.008-.038.039.005c.218 0 .437 0 .655-.008a1.229 1.229 0 0 0 .2-.039v-1.965h-2.691v1.967a1.328 1.328 0 0 1-.2.037c-.229.008-.458.009-.687.012v1.991h.923c.05-.009.1-.024.151-.031-.05.007-.1.022-.151.031h-.04v1.968l.035.009q.848 0 1.7-.007c.021 0 .043.022.064.033h.4c.163-.008.325-.026.487-.039v-1.963l-.855-.008zm-.022-2z",
    transform: "translate(-69 -33.884)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 215",
    d: "M124.345 110.989a.054.054 0 0 1 .006-.036l.028.034h-.017z",
    transform: "translate(-117.855 -106.974)",
    style: {
      fill: "#d3eefa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 216",
    d: "M90.566 149.972q.848 0 1.7-.007c.021 0 .043.022.064.033h-1.612a.815.815 0 0 1-.148-.027",
    transform: "translate(-85.84 -143.975)",
    style: {
      fill: "#ffc433"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChips);
export default __webpack_public_path__ + "static/media/chips.d2f9225e439054aec5fed31405da0461.svg";
export { ForwardRef as ReactComponent };